export default __webpack_public_path__ + "static/media/expired_recommend_h5.28ac482c.png";